import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  IconButton,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CommonButton from "../../../../Componants/Common/Button";
import deleteIcon from "../../../../Assests/deleteIcon.svg";
import CustomDatePicker from "../../../../Componants/Common/Custom Date Picker/CustomDatePicker";
import { Calendar } from "../../../../Componants/Common/Calender";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import {
  closeRepairWithPart,
  closeWithPartPending,
  closeWithReplacement,
  fetchBrandList,
  fetchCategoryList,
  fetchJobList,
  fetchModelList,
  fetchModelListActive,
  fetchPartList,
  fetchSubCategoryList,
  closeWithRemarks,
  fetchPartDetails,
  multiImageUpload,
  splitImageUpload,
  fetchJobStatus
} from "../../../../API Service/apiService";
import Loader from "../../../../Componants/Common/Loader";
import toast, { Toaster } from "react-hot-toast";
import dayjs from "dayjs";

const paymentOptions = [{ label: "Yes" }, { label: "No" }];
const paymentModeOptions = [
  { label: "Cash" },
  { label: "Cheque" },
  { label: "Online" },
];

// inWarranty, outOfWarranty, voidWarranty
const warrantyOptions = [
  { label: "In warranty", value: "inWarranty" },
  { label: "Out warranty", value: "outOfWarranty" },
  { label: "Warranty void", value: "voidWarranty" },
];
const actionOptions = [
  { value: 1, label: "Repair with part" },
  { value: 2, label: "Replacement" },
  { value: 3, label: "Part Pending" },
  { value: 4, label: "Resolved with Remarks" },
];

// First, update the initial state
const initialRepairParams = {
  jobId: 0,
  parts: [
    {
      partName: "",
      sparePartId: "",
      partSerialNumber: "",
      oldPartSerial: "",
      quantity: "",
      isSerialized: false,
    },
  ],
  payment: "",
  paymentMode: "",
  amount: "",
  paymentReferenceNumber: "",
  warrantyStatus: "",
  visitDate: "",
  visitTime: "",
  comment: "",
};

const initialReplacementParams = {
  jobId: 0,
  modelId: "",
  modelName: "",
  newSerialNumber: "",
  oldPartSerialNumber: "",
  warrantyStatus: "",
  comment: "",
  visitDate: "",
  visitTime: "",
  oldModelImages: "",
  newModelImages: "",
  payment: "",
  paymentMode: "",
  amount: "",
  paymentReferenceNumber: "",
};

const initialPartPendingParams = {
  jobId: 0,
  partPending: [
    { sparePartName: "", sparePartId: "", quantity: "", touched: false },
  ],
  warrantyStatus: "",
  remarks: "",
  visitDate: "",
  visitTime: "",
};
// {jobId,remarks,visitDate,visitTime}
const initialRemarksParams = {
  jobId: 0,
  remarks: "",
  visitDate: "",
  visitTime: "",
  touched: false,
};

const RepairUpdate = ({ jobID, onClose }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [files, setFiles] = useState([]);
  const [files2, setFiles2] = useState([]);
  const [loading, setLoading] = useState(false);
  const [brandList, setBrandList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [models, setModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubcategory, setSelectedSubcategory] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [partList, setPartList] = useState([]);
  const [repairListData, setRepairListData] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);
  const [repairWithPartParams, setRepairWithPartParams] =
    useState(initialRepairParams);
  const [replacementWithPartParams, setReplacementWithPartParams] = useState(
    initialReplacementParams
  );
  const [paymentImageFiles, setPaymentImageFiles] = useState([]);
  const [paymentImages, setPaymentImages] = useState([]);
  const [paymentImageReplacementFiles, setPaymentImageReplacementFiles] = useState([]);
  const [paymentImageReplacementImages, setPaymentImageReplacementImages] = useState([]);
  const [paymentImageReplacementValue, setPaymentImageReplacementValue] = useState([]);
  const [partPendingImages, setPartPendingImages] = useState([]);
  const [partPendingImageValue, setPartPendingImageValue] = useState([]);
  const [partPendingImageFiles, setPartPendingImageFiles] = useState([]);
  const [images, setImages] = useState([]);
  const [partPendingParams, setPartPendingParams] = useState(
    initialPartPendingParams
  );
  const [remarksDialogOpen, setRemarksDialogOpen] = useState(false);
  const [remarksParams, setRemarksParams] = useState(initialRemarksParams);
  const [qtyFlag, setQtyFlag] = useState(false);
  const [imageValue, setImageValue] = useState([]);
  const [imageOldReplacementValue, setImageOldReplacementValue] = useState([]);
  const [imageNewReplacementValue, setImageNewReplacementValue] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [fileName, setFileName] = useState("");
  const [visitDate, setVisitDate] = useState("");
  const [visitTime, setVisitTime] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(null);

  // Helper function to validate visit date and time combination
  const validateVisitDateTime = (date, time) => {
    if (!date) return true; // Allow if no date is selected yet
    
    const selectedDateTime = new Date(date);
    
    if (time) {
      const [hours, minutes] = time.split(':').map(Number);
      selectedDateTime.setHours(hours, minutes, 0, 0);
    } else {
      // If no time selected, set to start of the day
      selectedDateTime.setHours(0, 0, 0, 0);
    }
    
    const now = new Date();
    
    return selectedDateTime >= now;
  };

  const handleDateChange = (fieldName, date, formattedDate) => {
    // Validate that visit date cannot be less than today
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set to start of today
    
    if (date && date < today) {
      toast.error("Visit date cannot be less than today");
      return;
    }
    
    // Validate date and time combination if time is already selected
    if (date && visitTime && !validateVisitDateTime(date, visitTime)) {
      toast.error("Visit date and time combination cannot be in the past");
      return;
    }
    
    setSelectedDate(date);
    setVisitDate(date);
    
    // Update all params with the new date
    setRepairWithPartParams(prev => ({
      ...prev,
      visitDate: date
    }));
    
    setReplacementWithPartParams(prev => ({
      ...prev,
      visitDate: date
    }));
    
    setPartPendingParams(prev => ({
      ...prev,
      visitDate: date
    }));
    
    setRemarksParams(prev => ({
      ...prev,
      visitDate: date
    }));
  };

  const handlePurchaseDateChange = (fieldName, date, formattedDate) => {
    // Validate that purchase date cannot be greater than today
    const today = new Date();
    today.setHours(23, 59, 59, 999); // Set to end of today to allow today's date
    
    if (date && date > today) {
      toast.error("Purchase date cannot be greater than today");
      return;
    }
    
    setPurchaseDate(date);
  };

  const [time, setTime] = useState("");

  const handleTimeChange = (event) => {
    const value = event.target.value;
    
    // Validate that visit date and time combination is not in the past
    if (value && visitDate && !validateVisitDateTime(visitDate, value)) {
      toast.error("Visit date and time cannot be in the past");
      return;
    }
    
    setTime(value);
    setVisitTime(value);
    
    // Update all params with the new time
    setRepairWithPartParams(prev => ({
      ...prev,
      visitTime: value
    }));
    
    setReplacementWithPartParams(prev => ({
      ...prev,
      visitTime: value
    }));
    
    setPartPendingParams(prev => ({
      ...prev,
      visitTime: value
    }));
    
    setRemarksParams(prev => ({
      ...prev,
      visitTime: value
    }));
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFiles([...files, file]);
      setImageOldReplacementValue([]);
    }
  };
  const handleFileUpload2 = (event) => {
    const file2 = event.target.files[0];
    if (file2) {
      setFiles2([...files2, file2]);
      setImageNewReplacementValue([]);
    }
  };

  const handleFileDelete = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  const handleFileDelete2 = (index) => {
    const updatedFiles2 = files2.filter((_, i) => i !== index);
    setFiles2(updatedFiles2);
  };

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    const newImages = files.map((file) => URL.createObjectURL(file));
    setImages((prevImages) => [...prevImages, ...newImages]);
  };

  const handlePaymentImageChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + paymentImageFiles.length > 3) {
      toast.error("You can only upload up to 3 images");
      return;
    }

    // Optional: Add file size check
    const maxSize = 5 * 1024 * 1024; // 5MB
    const invalidFiles = files.filter(file => file.size > maxSize);
    if (invalidFiles.length > 0) {
      toast.error("Some files are too large. Maximum size is 5MB per file.");
      return;
    }

    const newImages = files.map((file) => URL.createObjectURL(file));
    setPaymentImages((prevImages) => [...prevImages, ...newImages]);
    setPaymentImageFiles((prevFiles) => [...prevFiles, ...files]);
    setImageValue([]);
  };

  const handlePaymentImageReplacementChange = (event) => {
    const files = Array.from(event.target.files);
    if (files.length + paymentImageReplacementFiles.length > 3) {
      toast.error("You can only upload up to 3 images");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    const invalidFiles = files.filter(file => file.size > maxSize);
    if (invalidFiles.length > 0) {
      toast.error("Some files are too large. Maximum size is 5MB per file.");
      return;
    }
    const newImages = files.map((file) => URL.createObjectURL(file));
    setPaymentImageReplacementImages((prevImages) => [...prevImages, ...newImages]);
    setPaymentImageReplacementFiles((prevFiles) => [...prevFiles, ...files]);
    setPaymentImageReplacementValue([]);
  };

  const handlePartImageChange = (event) => {
    const files = Array.from(event.target.files);

    if (files.length + partPendingParams.partPending.length > 3) {
      toast.error("You can only upload up to 3 images");
      return;
    }

    const maxSize = 5 * 1024 * 1024; // 5MB
    const invalidFiles = files.filter(file => file.size > maxSize);
    if (invalidFiles.length > 0) {
      toast.error("Some files are too large. Maximum size is 5MB per file.");
      return;
    }

    const newImages = files.map((file) => URL.createObjectURL(file));
    setPartPendingImages((prevImages) => [...prevImages, ...newImages]);
    setPartPendingImageFiles((prev) =>[...prev, ...files]);
    setPartPendingImageValue([]);
  };
  

  const handlePaymentImageDelete = (index) => {
    // Revoke the URL to prevent memory leaks
    URL.revokeObjectURL(paymentImages[index]);
    
    setPaymentImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setPaymentImageFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setImageValue([]);
  };

  const handlePaymentImageReplacementDelete = (index) => {
    // Revoke the URL to prevent memory leaks
    URL.revokeObjectURL(paymentImageReplacementImages[index]);
    
    setPaymentImageReplacementImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setPaymentImageReplacementFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setPaymentImageReplacementValue([]);
  };

  const handlePartPendingImageDelete = (index) => {
    // Revoke the URL to prevent memory leaks
    URL.revokeObjectURL(partPendingImages[index]);
    
    setPartPendingImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setPartPendingImageFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
    setPartPendingImageValue([]);
  };
  

  const resetForm = () => {
    // Cleanup URLs before resetting
    paymentImages.forEach(url => URL.revokeObjectURL(url));
    paymentImageReplacementImages.forEach(url => URL.revokeObjectURL(url));
    partPendingImages.forEach(url => URL.revokeObjectURL(url));
    
    setRepairWithPartParams(initialRepairParams);
    setReplacementWithPartParams(initialReplacementParams);
    setPaymentImages([]);
    setPaymentImageFiles([]);
    setPartPendingImages([]);
    setPartPendingImageFiles([]);
    setPaymentImageReplacementImages([]);
    setPaymentImageReplacementFiles([]);
    setFiles([]);
    setFiles2([]);
    setImages([]);
    setSelectedAction(null);
    setPartPendingParams(initialPartPendingParams);
    setSelectedDate(null);
    setVisitDate("");
  };

  const repairWithPart = async () => {
    try {
      setLoading(true);
      
      // Upload payment images if any
      let imagePath = [];
      let partPendingImagePath = [];
      if (paymentImageFiles && paymentImageFiles.length > 0 && imageValue.length === 0) {
        const paymentFormData = new FormData();
        paymentFormData.append("imageType", "payment");
        
        for (const file of paymentImageFiles) {
          paymentFormData.append("images", file);
        }
        
        try {
          const paymentImagesResponse = await multiImageUpload(paymentFormData);
          if (paymentImagesResponse.data && paymentImagesResponse.data.status === "success") {
            // Extract full paths from response into array
            imagePath = paymentImagesResponse.data.data.map(img => img.fullPath);
            setImageValue(imagePath);
          } else {
            throw new Error(paymentImagesResponse.data?.message || "Failed to upload payment images");
          }
        } catch (error) {
          console.error("Error uploading payment images:", error);
          toast.error(error.message || "Failed to upload payment images");
          setLoading(false);
          return;
        }
      }

      if (partPendingImageFiles && partPendingImageFiles.length > 0 && partPendingImageValue.length === 0) {
        const partPendingFormData = new FormData();
        partPendingFormData.append("imageType", "partPending");
        
        for (const file of partPendingImageFiles) {
          partPendingFormData.append("images", file);
        }

        try {
          const partPendingImagesResponse = await multiImageUpload(partPendingFormData);
          if (partPendingImagesResponse.data && partPendingImagesResponse.data.status === "success") {
            partPendingImagePath = partPendingImagesResponse.data.data.map(img => img.fullPath);
            setPartPendingImageValue(partPendingImagePath);
          } else {
            throw new Error(partPendingImagesResponse.data?.message || "Failed to upload part pending images");
          }
        } catch (error) {
          console.error("Error uploading part pending images:", error);
          toast.error(error.message || "Failed to upload part pending images");
          setLoading(false);
          return;
        }
      }
          

      const amount = parseFloat(repairWithPartParams.amount) || 0;

      const body = {
        jobId: jobID,
        amount: amount,
        payment: repairWithPartParams.payment,
        paymentMode: repairWithPartParams.paymentMode,
        paymentReferenceNumber: repairWithPartParams.paymentReferenceNumber,
        warrantyStatus: repairWithPartParams.warrantyStatus,
        visitDate: repairWithPartParams.visitDate,
        visitTime: repairWithPartParams.visitTime,
        repairPartDetails: repairWithPartParams.parts.map((part) => ({
          partName: part.partName,
          sparePartId: part.sparePartId,
          partSerialNumber: part.partSerialNumber,
          oldPartSerialNumber: part.oldPartSerial,
          isSerialized:part.isSerialized,
          quantity: parseInt(part.quantity) || 1,
        })),
        comment: repairWithPartParams.comment,
        imagePath: imagePath.length > 0 ? imagePath : imageValue,
        partPendingImagePath: partPendingImagePath.length > 0 ? partPendingImagePath : partPendingImageValue
      };

      const response = await closeRepairWithPart(body);
      if (response.status == 200) {
        toast.success(response.data.message || "Repair with part updated successfully");
        setImageValue([]);
        resetForm();
        onClose();
      } else {
        console.log("imagePath",imagePath);
        const errorMessage = response.data.error || response.data.message || "Failed to update repair with part";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error in repairing with part:", error);
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || "Failed to update repair with part";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const replacementWithPart = async () => {
    try {
      setLoading(true);
      
      // Upload both old and new model images in single call if any images exist
      let oldModelImagePaths = [];
      let newModelImagePaths = [];
      let paymentImageReplacementPaths = [];
      if (((files && files.length > 0) || (files2 && files2.length > 0)) && (imageOldReplacementValue.length === 0 ||  imageNewReplacementValue.length === 0)) {
        const imagesFormData = new FormData();
        imagesFormData.append("imageType", "replacementimage");
        
        // Append old model images if any
        if (files && files.length > 0) {
          for (const file of files) {
            imagesFormData.append("oldModelImages", file);
          }
        }
        
        // Append new model images if any
        if (files2 && files2.length > 0) {
          for (const file of files2) {
            imagesFormData.append("newModelImages", file);
          }
        }
        
        try {
          const imagesResponse = await splitImageUpload(imagesFormData);
          if (imagesResponse.data && imagesResponse.data.status === "success") {
            // Extract paths for both old and new images
            const responseData = imagesResponse.data;
            oldModelImagePaths = responseData.oldModelImages.map(img => img.fullPath);
            newModelImagePaths = responseData.newModelImages.map(img => img.fullPath);
            setImageOldReplacementValue(oldModelImagePaths);
            setImageNewReplacementValue(newModelImagePaths);
          } else {
            throw new Error(imagesResponse.data?.message || "Failed to upload images");
          }
        } catch (error) {
          console.error("Error uploading images:", error);
          toast.error(error.message || "Failed to upload images");
          setLoading(false);
          return;
        }
      }

      if (paymentImageReplacementFiles && paymentImageReplacementFiles.length > 0 && paymentImageReplacementValue.length === 0) {
        const paymentReplacementFormData = new FormData();
        paymentReplacementFormData.append("imageType", "paymentReplacement");
        
        for (const file of paymentImageReplacementFiles) {
          paymentReplacementFormData.append("images", file);
        }

        try {
          const paymentReplacementImagesResponse = await multiImageUpload(paymentReplacementFormData);
          if (paymentReplacementImagesResponse.data && paymentReplacementImagesResponse.data.status === "success") {
            paymentImageReplacementPaths = paymentReplacementImagesResponse.data.data.map(img => img.fullPath);
            setPaymentImageReplacementValue(paymentImageReplacementPaths);
          } else {
            throw new Error(paymentReplacementImagesResponse.data?.message || "Failed to upload payment replacement images");
          }
        } catch (error) {
          console.error("Error uploading payment replacement images:", error);
          toast.error(error.message || "Failed to upload payment replacement images");
          setLoading(false);
          return;
        }
      }
      
      const body = {
        jobId: jobID,
        modelId: replacementWithPartParams.modelId,
        modelName: replacementWithPartParams.modelName,
        newSerialNumber: replacementWithPartParams.newSerialNumber || 0,
        oldPartSerialNumber:replacementWithPartParams.oldPartSerialNumber || 0,
        visitDate: replacementWithPartParams.visitDate,
        visitTime: replacementWithPartParams.visitTime,
        warrantyStatus: repairWithPartParams.warrantyStatus,
        comment: replacementWithPartParams.comment,
        amount: parseFloat(replacementWithPartParams.amount) || 0,
        payment: replacementWithPartParams.payment,
        paymentMode: replacementWithPartParams.paymentMode,
        paymentReferenceNumber: replacementWithPartParams.paymentReferenceNumber,
        oldModelImages: oldModelImagePaths.length > 0 ? oldModelImagePaths : imageOldReplacementValue,
        newModelImages: newModelImagePaths.length > 0 ? newModelImagePaths : imageNewReplacementValue,
        paymentImagePath: paymentImageReplacementPaths.length > 0 ? paymentImageReplacementPaths : paymentImageReplacementValue
      };

      const response = await closeWithReplacement(body);
      if (response.status === 200) {
        toast.success(response.data.message || "Replacement updated successfully");
        setImageOldReplacementValue([]);
        setImageNewReplacementValue([]);
        setPaymentImageReplacementValue([]);
        resetForm();
        onClose();
      } else {
        const errorMessage = response.data.error || response.data.message || "Failed to update replacement";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error in replacing with part:", error);
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || "Failed to update replacement";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handlePartChange = (index, field, value) => {
    setPartPendingParams((prev) => ({
      ...prev,
      partPending: prev.partPending.map((part, i) => {
        if (i === index) {
          if (field === "part") {
            return {
              ...part,
              sparePartName: value?.sparePartName || "",
              sparePartId: value?._id || "",
              touched: true,
            };
          }
          if (field === "quantity") {
            const numericValue = value.replace(/[^0-9]/g, "");
            return { ...part, quantity: numericValue, touched: true };
          }
          return { ...part, [field]: value, touched: true };
        }
        return part;
      }),
    }));
  };

  const validatePartPending = () => {
    setPartPendingParams((prev) => ({
      ...prev,
      partPending: prev.partPending.map((part) => ({
        ...part,
        touched: true,
      })),
    }));

    return partPendingParams.partPending.every(
      (part) => part.sparePartName && part.quantity
    );
  };

  const partPending = async () => {
    try {
      setLoading(true);
      
      let imagePath = [];
      
      if (files && files.length > 0) {
        const imagesFormData = new FormData();
        imagesFormData.append("imageType", "partPending");
        
        for (const file of files) {
          imagesFormData.append("images", file);
        }
        
        try {
          const imagesResponse = await multiImageUpload(imagesFormData);
          if (imagesResponse.data && imagesResponse.data.status === "success") {
            imagePath = imagesResponse.data.data.map(img => img.fullPath);
          } else {
            throw new Error(imagesResponse.data?.message || "Failed to upload images");
          }
        } catch (error) {
          console.error("Error uploading part pending images:", error);
          toast.error(error.message || "Failed to upload part pending images");
          setLoading(false);
          return;
        }
      }

      const requestData = {
        jobId: jobID,
        partPending: partPendingParams.partPending.map((part) => ({
          sparePartName: part.sparePartName,
          sparePartId: part.sparePartId,
          quantity: parseInt(part.quantity) || 0,
        })),
        visitDate: partPendingParams.visitDate,
        visitTime: partPendingParams.visitTime,
        warrantyStatus: repairWithPartParams.warrantyStatus,
        remarks: partPendingParams.remarks,
        imagePath: imagePath
      };

      const response = await closeWithPartPending(requestData);
      if (response.status === 200) {
        toast.success(response.data.message || "Part pending updated successfully");
        resetForm();
        onClose();
      } else {
        const errorMessage = response.data.error || response.data.message || "Failed to update part pending";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error in repairing with part pending:", error);
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || "Failed to update repair with part pending";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const getPartlist = async () => {
    try {
      setLoading(true);
      const response = await fetchPartDetails();
      setPartList(response.data.data || []);
    } catch (error) {
      console.error("Error fetching part list:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const getJobList = async () => {
    try {
      setLoading(true);
      const params = { jobId: jobID };
      const response = await fetchJobList(params);
      if (response.status === 200) {
        setRepairListData(response.data.jobList || []);
      } else {
        console.error("Error in fetching jobs");
      }
    } catch (error) {
      console.error(`Error in fetching jobs: ${error.message}`);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getPartlist();
    getJobList();
    setRepairWithPartParams((prev) => ({
      ...prev,
      jobId: jobID,
    }));
  }, []);

  useEffect(() => {
    if (repairListData[0]?.productDetails?.serialNo) {
      setRepairWithPartParams((prev) => ({
        ...prev,
        jobId: jobID,
      }));

      setRemarksParams((prev) => ({
        ...prev,
      }));

      // Initialize purchase date from the data
      if (repairListData[0]?.productDetails?.invoiceDate) {
        try {
          const invoiceDate = repairListData[0].productDetails.invoiceDate;
          console.log("Invoice date from API:", invoiceDate);
          
          // Try different date formats
          let purchaseDateValue = null;
          
          // Try DD-MM-YYYY format first
          if (dayjs(invoiceDate, "DD-MM-YYYY", true).isValid()) {
            purchaseDateValue = dayjs(invoiceDate, "DD-MM-YYYY").toDate();
          }
          // Try YYYY-MM-DD format
          else if (dayjs(invoiceDate, "YYYY-MM-DD", true).isValid()) {
            purchaseDateValue = dayjs(invoiceDate, "YYYY-MM-DD").toDate();
          }
          // Try ISO format
          else if (dayjs(invoiceDate).isValid()) {
            purchaseDateValue = dayjs(invoiceDate).toDate();
          }
          
          console.log("Parsed purchase date:", purchaseDateValue);
          if (purchaseDateValue) {
            // Validate that purchase date from API cannot be greater than today
            const today = new Date();
            today.setHours(23, 59, 59, 999); // Set to end of today to allow today's date
            
            if (purchaseDateValue > today) {
              console.warn("Purchase date from API is in the future, setting to today's date");
              toast.error("Purchase date from API is in the future. Please select a valid date.");
              setPurchaseDate(today);
            } else {
              setPurchaseDate(purchaseDateValue);
            }
          }
        } catch (error) {
          console.error("Error parsing purchase date:", error);
        }
      }
    }
  }, [repairListData]);

  const handleCancel = () => {
    resetForm();
    setSelectedBrand(null);
    setSelectedCategory(null);
    setSelectedSubcategory(null);
    setSelectedModel(null);
    setFiles([]);
    setFiles2([]);
    setSelectedAction(null);
    setSelectedDate(null);
    setTime("");
    setVisitDate("");
    setVisitTime("");
    setPurchaseDate(null);
    setReplacementWithPartParams({
      jobId: 0,
      modelId: "",
      modelName: "",
      newSerialNumber: "",
      oldPartSerialNumber: "",
      warrantyStatus: "",
      comment: "",
      oldModelImages: "",
      newModelImages: "",
      visitDate: "",
      visitTime: "",
    });
  };

  const isAlphanumeric = (str) => /^[a-zA-Z0-9]*$/.test(str);
  const isNumeric = (str) => /^\d*\.?\d*$/.test(str);

  const fetchBrandListData = async () => {
    try {
      setLoading(true);
      const brandResponse = await fetchBrandList();
      setBrandList(brandResponse.data.brandList || []);
    } catch (error) {
      console.error("Error fetching initial data:", error);
      toast.error("Failed to fetch initial data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!selectedBrand?._id) return;
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const response = await fetchCategoryList(
          selectedBrand._id,
          "",
          1,
          10,
          true
        );
        setCategories(response.data.categories || []);
      } catch (error) {
        console.error("Error fetching categories:", error);
        toast.error("Failed to fetch categories");
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, [selectedBrand]);

  useEffect(() => {
    if (!selectedBrand?._id || !selectedCategory?._id) return;
    const fetchSubcategories = async () => {
      try {
        setLoading(true);
        const response = await fetchSubCategoryList(
          "",
          1,
          10,
          selectedBrand._id,
          selectedCategory._id
        );
        setSubcategories(response.data.subcategory || []);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
        toast.error("Failed to fetch subcategories");
      } finally {
        setLoading(false);
      }
    };
    fetchSubcategories();
  }, [selectedCategory, selectedBrand]);

  useEffect(() => {
    if (
      !selectedBrand?._id ||
      !selectedCategory?._id ||
      !selectedSubcategory?._id
    )
      return;
    const fetchModels = async () => {
      try {
        setLoading(true);
        const response = await fetchModelListActive(
          "",
          1,
          10,
          selectedBrand._id,
          selectedCategory._id,
          selectedSubcategory._id
        );
        setModels(response.data.models || []);
      } catch (error) {
        console.error("Error fetching models:", error);
        toast.error("Failed to fetch models");
      } finally {
        setLoading(false);
      }
    };
    fetchModels();
  }, [selectedSubcategory, selectedCategory, selectedBrand]);

  useEffect(() => {
    fetchBrandListData();
  }, []);

  const handleAddPart = () => {
    const hasInvalidFields = repairWithPartParams.parts.some(
      (part) => !part.partName || (!part.partSerialNumber && !part.quantity)
    );

    if (!hasInvalidFields) {
      setRepairWithPartParams((prev) => ({
        ...prev,
        parts: [
          ...prev.parts,
          {
            partName: "",
            sparePartId: "",
            partSerialNumber: "",
            oldPartSerial: "",
            quantity: "",
            isSerialized: false,
          },
        ],
      }));
    }
  };

  const handleDeletePart = (index) => {
    setRepairWithPartParams((prev) => ({
      ...prev,
      parts: prev.parts.filter((_, i) => i !== index),
    }));
  };

  const handleRemarksDialogClose = () => {
    setRemarksDialogOpen(false);
  };

  const handleRemarksSubmit = async () => {
    setRemarksParams((prev) => ({ ...prev, touched: true }));

    if (!remarksParams.remarks.trim()) {
      return;
    }

    try {
      setLoading(true);
      const requestData = {
        jobId: jobID,
        remarks: remarksParams.remarks,
        visitDate: remarksParams.visitDate,
        visitTime: remarksParams.visitTime,
      };

      const response = await closeWithRemarks(requestData);
      if (response.status === 200) {
        toast.success(response.data.message || "Remarks updated successfully");
        handleRemarksDialogClose();
        resetForm();
        onClose();
      } else {
        const errorMessage = response.data.error || response.data.message || "Failed to update remarks";
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error in updating remarks:", error);
      const errorMessage = error.response?.data?.error || error.response?.data?.message || error.message || "Failed to update remarks";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ backgroundColor: "#EFF3FE" }}>
      {loading && <Loader />}
      <Toaster />
      <Typography variant="h5" align="center" gutterBottom>
        Repair Update
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="Customer name"
            variant="standard"
            size="small"
            value={repairListData[0]?.customerDetails.customerName || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="City"
            variant="standard"
            size="small"
            value={repairListData[0]?.serviceCenterDetails.city || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="Service Type"
            variant="standard"
            size="small"
            value={repairListData[0]?.jobDetails.serviceType || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="Jobsheet Type"
            variant="standard"
            value={repairListData[0]?.jobDetails.jobsheetType || ""}
            readOnly={true}
            size="small"
            sx={{ width: "10rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="Fault as observed by Customer"
            variant="standard"
            size="small"
            value={repairListData[0]?.jobDetails.faltObserverByCustomer || ""}
            readOnly={true}
            sx={{ width: "15rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={4} md={4}>
          <TextField
            label="Remark"
            variant="standard"
            size="small"
            value={repairListData[0]?.jobDetails.remarksr || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>
      </Grid>
      <br />
      <hr /> <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <Typography sx={{ fontSize: "900", fontWeight: "600" }}>
            Job Details
          </Typography>
        </Grid>
      </Grid>
      <br />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            label="Product Name"
            variant="standard"
            size="small"
            value={repairListData[0]?.brandDetails.brandName || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            label="Product Code"
            variant="standard"
            size="small"
            value={repairListData[0]?.jobDetails.jobNumber || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <Calendar
            value={
              purchaseDate || (repairListData[0]?.productDetails?.invoiceDate
                ? (() => {
                    try {
                      const invoiceDate = repairListData[0].productDetails.invoiceDate;
                      let parsedDate = null;
                      
                      // Try different date formats
                      if (dayjs(invoiceDate, "DD-MM-YYYY", true).isValid()) {
                        parsedDate = dayjs(invoiceDate, "DD-MM-YYYY").toDate();
                      } else if (dayjs(invoiceDate, "YYYY-MM-DD", true).isValid()) {
                        parsedDate = dayjs(invoiceDate, "YYYY-MM-DD").toDate();
                      } else if (dayjs(invoiceDate).isValid()) {
                        parsedDate = dayjs(invoiceDate).toDate();
                      }
                      
                      // Validate that parsed date is not in the future
                      if (parsedDate) {
                        const today = new Date();
                        today.setHours(23, 59, 59, 999);
                        
                        if (parsedDate > today) {
                          console.warn("Purchase date from API is in the future, not displaying it");
                          return null;
                        }
                        return parsedDate;
                      }
                    } catch (error) {
                      console.error("Error parsing invoice date in Calendar:", error);
                    }
                    return null;
                  })()
                : null)
            }
            handleChange={handlePurchaseDateChange}
            fieldName="purchaseDate"
            label="Purchase Date"
            readOnly={false}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <TextField
            label="Engineer Assigned"
            variant="standard"
            size="small"
            value={repairListData[0]?.jobDetails.assignedEngineerName || ""}
            readOnly={true}
            sx={{ width: "10rem" }}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <Autocomplete
            id="disable-close-on-select"
            options={warrantyOptions}
            getOptionLabel={(option) => option.label}
            value={
              warrantyOptions.find(
                (option) => option.value === repairWithPartParams.warrantyStatus
              ) || null
            }
            onChange={(_, newValue) => {
              setRepairWithPartParams((prev) => ({
                ...prev,
                warrantyStatus: newValue?.value || "",
              }));
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Warranty Status"
                variant="standard"
                style={{ width: "11rem" }}
              />
            )}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <Calendar
            value={selectedDate}
            handleChange={handleDateChange}
            fieldName="visitDate"
            label="Visit Date"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              label="Visit Time"
              value={visitTime ? dayjs(visitTime, 'HH:mm') : null}
              onChange={(newValue) => {
                if (newValue && newValue.isValid()) {
                  const formattedTime = newValue.format('HH:mm');
                  handleTimeChange({ target: { value: formattedTime } });
                }
              }}
              minTime={
                selectedDate && dayjs(selectedDate).isSame(dayjs(), 'day') 
                  ? dayjs().add(1, 'minute') 
                  : dayjs().startOf('day')
              }
              slotProps={{
                textField: {
                  variant: "standard",
                  sx: { width: "10rem" },
                  InputLabelProps: {
                    shrink: true,
                  }
                }
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={3} md={3}></Grid>
        <Grid item xs={12} sm={3} md={3}>
          <Autocomplete
            id="disable-close-on-select"
            options={actionOptions}
            getOptionLabel={(option) => option.label}
            value={
              actionOptions.find((option) => option.value === selectedAction) ||
              null
            }
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
            onChange={(event, newValue) => {
              console.log("newValue",newValue)
              // if (newValue?.value === 2) {
              //   if (repairWithPartParams.warrantyStatus === "outOfWarranty") {
              //     toast.error("No replacement for out warranty");
              //     return;
              //   } else if (
              //     repairWithPartParams.warrantyStatus === "voidWarranty"
              //   ) {
              //     toast.error("No replacement for void warranty");
              //     return;
              //   }
              // }
              setSelectedAction(newValue?.value);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Action"
                variant="standard"
                style={{ width: "11rem" }}
              />
            )}
          />
        </Grid>
      </Grid>
      <br />
      {selectedAction === 1 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={3}>
            <Typography sx={{ fontSize: "900", fontWeight: "600" }}>
              Repair with Part
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={9}
            md={9}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          ></Grid>
        </Grid>
      )}
      {selectedAction === 1 && (
        <>
          <br />
          {repairWithPartParams.parts.map((part, index) => (
            <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
              <Grid item xs={12} sm={3} md={3}>
                <Autocomplete
                  id={`part-name-${index}`}
                  options={partList}
                  getOptionLabel={(option) => option.sparePartName || ""}
                  value={
                    partList.find(
                      (option) => option.sparePartName === part.partName
                    ) || null
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.sparePartName === value.sparePartName
                  }
                  onChange={(_, newValue) => {
                    const updatedParts = [...repairWithPartParams.parts];
                    updatedParts[index] = {
                      ...updatedParts[index],
                      partName: newValue?.sparePartName || "",
                      sparePartId: newValue?._id || "",
                      isSerialized: newValue?.isSerialized || false,
                      partSerialNumber: "",
                      quantity: "",
                    };
                    setRepairWithPartParams((prev) => ({
                      ...prev,
                      parts: updatedParts,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Part Name"
                      variant="standard"
                      style={{ width: "11rem" }}
                    />
                  )}
                />
              </Grid>
              {part.isSerialized ? (
                <>
                  <Grid item xs={12} sm={3} md={3}>
                    <TextField
                      label="Part Serial"
                      variant="standard"
                      size="small"
                      sx={{ width: "10rem" }}
                      value={part.partSerialNumber}
                      error={
                        part.partSerialNumber !== "" &&
                        !isAlphanumeric(part.partSerialNumber)
                      }
                      helperText={
                        part.partSerialNumber !== "" &&
                        !isAlphanumeric(part.partSerialNumber)
                          ? "Only alphanumeric characters allowed"
                          : ""
                      }
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value === "" || isAlphanumeric(value)) {
                          const updatedParts = [...repairWithPartParams.parts];
                          updatedParts[index] = {
                            ...updatedParts[index],
                            partSerialNumber: value,
                            isSerialized:true
                          };
                          setRepairWithPartParams((prev) => ({
                            ...prev,
                            parts: updatedParts,
                          }));
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={3} md={3}>
                    <TextField
                      label="Old Part Serial"
                      variant="standard"
                      size="small"
                      value={part.oldPartSerial}
                      onChange={(e) => {
                        const updatedParts = [...repairWithPartParams.parts];
                        updatedParts[index] = {
                          ...updatedParts[index],
                          oldPartSerial: e.target.value,
                        };
                        setRepairWithPartParams((prev) => ({
                          ...prev,
                          parts: updatedParts,
                        }));
                      }}
                      sx={{ width: "10rem" }}
                    />
                  </Grid>
                </>
              ) : (
                <Grid item xs={12} sm={3} md={3}>
                  <TextField
                    label="Quantity"
                    variant="standard"
                    size="small"
                    sx={{ width: "10rem" }}
                    value={part.quantity}
                    type="number"
                    inputProps={{ min: "1" }}
                    onChange={(e) => {
                      const updatedParts = [...repairWithPartParams.parts];
                      updatedParts[index] = {
                        ...updatedParts[index],
                        quantity: e.target.value,
                      };
                      setRepairWithPartParams((prev) => ({
                        ...prev,
                        parts: updatedParts,
                      }));
                    }}
                  />
                </Grid>
              )}
              {index === 0 && (
                <Grid
                  item
                  xs={12}
                  sm={3}
                  md={3}
                  sx={{
                    display: "flex",
                    alignItems: "flex-end",
                    paddingBottom: "5px",
                  }}
                >
                  <CommonButton
                    name="Add parts"
                    handleOnClick={() => {
                      setRepairWithPartParams((prev) => ({
                        ...prev,
                        parts: [
                          ...prev.parts,
                          {
                            partName: "",
                            sparePartId: "",
                            partSerialNumber: "",
                            oldPartSerial: "",
                            quantity: "",
                            isSerialized: false,
                          },
                        ],
                      }));
                    }}
                  />
                </Grid>
              )}
              {repairWithPartParams.parts.length > 1 && index !== 0 && (
                <Grid
                  item
                  xs={12}
                  sm={1}
                  md={1}
                  sx={{ display: "flex", alignItems: "center" }}
                >
                  <IconButton
                    onClick={() => {
                      setRepairWithPartParams((prev) => ({
                        ...prev,
                        parts: prev.parts.filter((_, i) => i !== index),
                      }));
                    }}
                    sx={{
                      padding: "8px",
                      backgroundColor: "#f5f5f5",
                      "&:hover": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  >
                    <img
                      src={deleteIcon}
                      alt="delete"
                      height="20px"
                      width="20px"
                    />
                  </IconButton>
                </Grid>
              )}
            </Grid>
          ))}
          <Grid container>
            <Grid item xs={12} sm={3} md={4}>
              <Autocomplete
                id="disable-close-on-select"
                options={paymentOptions}
                getOptionLabel={(option) => option.label}
                value={
                  paymentOptions.find(
                    (option) => option.label === repairWithPartParams.payment
                  ) || null
                }
                onChange={(_, newValue) => {
                  setRepairWithPartParams((prev) => ({
                    ...prev,
                    payment: newValue?.label || "",
                    paymentMode:
                      newValue?.label !== "Yes" ? "" : prev.paymentMode,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment"
                    variant="standard"
                    style={{ width: "11rem" }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={4}>
              <Autocomplete
                id="payment-mode"
                options={paymentModeOptions}
                disabled={repairWithPartParams.payment !== "Yes"}
                value={
                  paymentModeOptions.find(
                    (option) =>
                      option.label === repairWithPartParams.paymentMode
                  ) || null
                }
                onChange={(event, newValue) => {
                  setRepairWithPartParams((prev) => ({
                    ...prev,
                    paymentMode: newValue?.label || "",
                  }));
                }}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Mode"
                    variant="standard"
                    style={{ width: "11rem" }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={4}>
              <TextField
                label="Amount"
                variant="standard"
                size="small"
                type="text"
                sx={{ width: "10rem" }}
                value={repairWithPartParams.amount}
                error={
                  repairWithPartParams.amount !== "" &&
                  !isNumeric(repairWithPartParams.amount)
                }
                helperText={
                  repairWithPartParams.amount !== "" &&
                  !isNumeric(repairWithPartParams.amount)
                    ? "Only numbers allowed"
                    : ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || isNumeric(value)) {
                    setRepairWithPartParams((prev) => ({
                      ...prev,
                      amount: value,
                    }));
                  }
                }}
              />
            </Grid>
          </Grid>
          <Grid item xs={12} sm={3} md={4}>
            <TextField
              label="Payment Reference No"
              variant="standard"
              size="small"
              value={repairWithPartParams.paymentReferenceNumber}
              error={
                repairWithPartParams.paymentReferenceNumber !== "" &&
                !isAlphanumeric(repairWithPartParams.paymentReferenceNumber)
              }
              helperText={
                repairWithPartParams.paymentReferenceNumber !== "" &&
                !isAlphanumeric(repairWithPartParams.paymentReferenceNumber)
                  ? "Only alphanumeric characters allowed"
                  : ""
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || isAlphanumeric(value)) {
                  setRepairWithPartParams((prev) => ({
                    ...prev,
                    paymentReferenceNumber: value,
                  }));
                }
              }}
              sx={{ width: "12rem" }}
            />
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={10} md={8}>
              <Grid item xs={12} sm={12} md={12}>
                <input
                  type="file"
                  onChange={handlePaymentImageChange}
                  accept=".jpg, .png, .svg"
                  multiple
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    border: "none",
                    outline: "none",
                    width: "100%",
                    maxWidth: "300px",
                    fontSize: "14px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                />
              </Grid>

              {paymentImageFiles.length > 0 && (
                <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#1976d2" }}>
                        <TableCell sx={{ color: "white" }}>S.No</TableCell>
                        <TableCell sx={{ color: "white" }}>File</TableCell>
                        <TableCell sx={{ color: "white" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paymentImageFiles.map((file, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{file.name}</TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => handlePaymentImageDelete(index)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                              }}
                            >
                              <img
                                src={deleteIcon}
                                alt="delete"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
                <p style={{ fontSize: "900", color: "#32499F", marginBottom: "10px" }}>
                Upload Payment Images (Upload up to 3 images*)
              </p>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={10} md={8}>
              <Grid item xs={12} sm={12} md={12}>
                <input
                  type="file"
                  onChange={handlePartImageChange}
                  accept=".jpg, .png, .svg"
                  multiple
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    border: "none",
                    outline: "none",
                    width: "100%",
                    maxWidth: "300px",
                    fontSize: "14px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                />
              </Grid>
              {partPendingImageFiles.length > 0 && (
                <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#1976d2" }}>
                        <TableCell sx={{ color: "white" }}>S.No</TableCell>
                        <TableCell sx={{ color: "white" }}>File</TableCell>
                        <TableCell sx={{ color: "white" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {partPendingImageFiles.map((file, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{file.name}</TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => handlePartPendingImageDelete(index)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                              }}
                            >
                              <img
                                src={deleteIcon}
                                alt="delete"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
                <p style={{ fontSize: "900", color: "#32499F", marginBottom: "10px" }}>
                Upload Part Images (Upload up to 3 images*)
              </p>
            </Grid>
          </Grid>
        </>
      )}
      <br />
      {selectedAction === 2 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={3}>
            <Typography sx={{ fontSize: "900", fontWeight: "600" }}>
              Replacement
            </Typography>
          </Grid>
        </Grid>
      )}
      {selectedAction === 2 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={3}>
            <Autocomplete
              id="brand-autocomplete"
              options={brandList}
              getOptionLabel={(option) => option.brandName || ""}
              value={selectedBrand}
              onChange={(event, newValue) => {
                setSelectedBrand(newValue);
                setSelectedCategory(null);
                setSelectedSubcategory(null);
                setSelectedModel(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Brand"
                  variant="standard"
                  style={{ width: "11rem" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Autocomplete
              id="category-autocomplete"
              options={categories}
              getOptionLabel={(option) => option.categoryName || ""}
              value={selectedCategory}
              onChange={(event, newValue) => {
                setSelectedCategory(newValue);
                setSelectedSubcategory(null);
                setSelectedModel(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Category"
                  variant="standard"
                  style={{ width: "11rem" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Autocomplete
              id="subcategory-autocomplete"
              options={subcategories}
              getOptionLabel={(option) => option.subcategoryName || ""}
              value={selectedSubcategory}
              onChange={(event, newValue) => {
                setSelectedSubcategory(newValue);
                setSelectedModel(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Sub Category"
                  variant="standard"
                  style={{ width: "11rem" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <Autocomplete
              id="model-autocomplete"
              options={models}
              getOptionLabel={(option) => option.modelName || ""}
              value={selectedModel}
              onChange={(event, newValue) => {
                setSelectedModel(newValue);
                setReplacementWithPartParams((prev) => ({
                  ...prev,
                  modelId: newValue?._id || "",
                  modelName: newValue?.modelName || "",
                }));
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Model"
                  variant="standard"
                  style={{ width: "11rem" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={3}>
            <TextField
              label="Serial No"
              variant="standard"
              value={replacementWithPartParams.newSerialNumber}
              onChange={(e) => {
                const value = e.target.value;
                setReplacementWithPartParams((prev) => ({
                  ...prev,
                  newSerialNumber: value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={4}>
            <TextField
              label="Old Part Serial"
              variant="standard"
              size="small"
              value={replacementWithPartParams.oldPartSerialNumber}
              onChange={(e) => {
                const value = e.target.value;
                setReplacementWithPartParams((prev) => ({
                  ...prev,
                  oldPartSerialNumber: value,
                }));
              }}
            />
          </Grid>
          <Grid item xs={12} sm={3} md={4}>
              <Autocomplete
                id="disable-close-on-select"
                options={paymentOptions}
                getOptionLabel={(option) => option.label}
                value={
                  paymentOptions.find(
                    (option) => option.label === replacementWithPartParams.payment
                  ) || null
                }
                onChange={(_, newValue) => {
                  setReplacementWithPartParams((prev) => ({
                    ...prev,
                    payment: newValue?.label || "",
                    paymentMode:
                      newValue?.label !== "Yes" ? "" : prev.paymentMode,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment"
                    variant="standard"
                    style={{ width: "11rem" }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={4}>
              <Autocomplete
                id="payment-mode"
                options={paymentModeOptions}
                disabled={replacementWithPartParams.payment !== "Yes"}
                value={
                  paymentModeOptions.find(
                    (option) =>
                      option.label === replacementWithPartParams.paymentMode
                  ) || null
                }
                onChange={(event, newValue) => {
                  setReplacementWithPartParams((prev) => ({
                    ...prev,
                    paymentMode: newValue?.label || "",
                  }));
                }}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Payment Mode"
                    variant="standard"
                    style={{ width: "11rem" }}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={4}>
              <TextField
                label="Amount"
                variant="standard"
                size="small"
                type="text"
                sx={{ width: "10rem" }}
                value={replacementWithPartParams.amount}
                error={
                  replacementWithPartParams.amount !== "" &&
                  !isNumeric(replacementWithPartParams.amount)
                }
                helperText={
                  replacementWithPartParams.amount !== "" &&
                  !isNumeric(replacementWithPartParams.amount)
                    ? "Only numbers allowed"
                    : ""
                }
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "" || isNumeric(value)) {
                      setReplacementWithPartParams((prev) => ({
                      ...prev,
                      amount: value,
                    }));
                  }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3} md={4}>
            <TextField
              label="Payment Reference No"
              variant="standard"
              size="small"
              value={replacementWithPartParams.paymentReferenceNumber}
              error={
                replacementWithPartParams.paymentReferenceNumber !== "" &&
                !isAlphanumeric(replacementWithPartParams.paymentReferenceNumber)
              }
              helperText={
                replacementWithPartParams.paymentReferenceNumber !== "" &&
                !isAlphanumeric(replacementWithPartParams.paymentReferenceNumber)
                  ? "Only alphanumeric characters allowed"
                  : ""
              }
              onChange={(e) => {
                const value = e.target.value;
                if (value === "" || isAlphanumeric(value)) {
                  setReplacementWithPartParams((prev) => ({
                    ...prev,
                    paymentReferenceNumber: value,
                  }));
                }
              }}
              sx={{ width: "12rem" }}
            />
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={10} md={8}>
              <Grid item xs={12} sm={12} md={12}>
                <input
                  type="file"
                  onChange={handlePaymentImageReplacementChange}
                  accept=".jpg, .png, .svg"
                  multiple
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    border: "none",
                    outline: "none",
                    width: "100%",
                    maxWidth: "300px",
                    fontSize: "14px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                />
              </Grid>

              {paymentImageReplacementFiles.length > 0 && (
                <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow sx={{ backgroundColor: "#1976d2" }}>
                        <TableCell sx={{ color: "white" }}>S.No</TableCell>
                        <TableCell sx={{ color: "white" }}>File</TableCell>
                        <TableCell sx={{ color: "white" }}>Action</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {paymentImageReplacementFiles.map((file, index) => (
                        <TableRow key={index}>
                          <TableCell>{index + 1}</TableCell>
                          <TableCell>{file.name}</TableCell>
                          <TableCell>
                            <IconButton
                              onClick={() => handlePaymentImageReplacementDelete(index)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                              }}
                            >
                              <img
                                src={deleteIcon}
                                alt="delete"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
                <p style={{ fontSize: "900", color: "#32499F", marginBottom: "10px" }}>
                Upload Payment Images (Upload up to 3 images*)
              </p>
            </Grid>
          </Grid>
          

          {/* Product Taken Images */}
          <Grid s={{ padding: "20px", width: "400px" }} xs={12} sm={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "400", marginBottom: "10px" }}>
                  Old Model Images
                </Typography>
                <input
                  type="file"
                  onChange={handleFileUpload}
                  accept=".jpg, .png, .svg"
                  multiple
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    border: "none",
                    outline: "none",
                    width: "100%",
                    maxWidth: "300px",
                    fontSize: "14px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                />
              </Grid>
            </Grid>

            {files.length > 0 && (
              <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                      <TableCell sx={{ color: "white" }}>S.No</TableCell>
                      <TableCell sx={{ color: "white" }}>File</TableCell>
                      <TableCell sx={{ color: "white" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {files.map((file, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.name}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => handleFileDelete(index)}
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              height="20px"
                              width="20px"
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>

          {/* Product Given Images */}
          <Grid s={{ padding: "20px", width: "400px" }} xs={12} sm={6} md={6}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{ fontSize: "400", marginBottom: "10px" }}>
                  New Model Images
                </Typography>
                <input
                  type="file"
                  onChange={handleFileUpload2}
                  accept=".jpg, .png, .svg"
                  multiple
                  style={{
                    padding: "8px",
                    cursor: "pointer",
                    border: "none",
                    outline: "none",
                    width: "100%",
                    maxWidth: "300px",
                    fontSize: "14px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "4px",
                  }}
                />
              </Grid>
            </Grid>

            {files2.length > 0 && (
              <TableContainer component={Paper} sx={{ marginTop: "15px" }}>
                <Table size="small">
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#1976d2" }}>
                      <TableCell sx={{ color: "white" }}>S.No</TableCell>
                      <TableCell sx={{ color: "white" }}>File</TableCell>
                      <TableCell sx={{ color: "white" }}>Action</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {files2.map((file2, index) => (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file2.name}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() => handleFileDelete2(index)}
                            sx={{
                              outline: "none",
                              "&:focus": { outline: "none" },
                            }}
                          >
                            <img
                              src={deleteIcon}
                              alt="delete"
                              height="20px"
                              width="20px"
                            />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
      )}
      <br />
      {selectedAction === 3 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={3}>
            <Typography sx={{ fontSize: "900", fontWeight: "600" }}>
              Part Pending
            </Typography>
          </Grid>
        </Grid>
      )}
      {selectedAction === 3 && (
        <Grid container spacing={2}>
          {partPendingParams.partPending.map((part, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} sm={3} md={4}>
                <Autocomplete
                  options={partList}
                  getOptionLabel={(option) => option.sparePartName || ""}
                  value={
                    partList.find((p) => p._id === part.sparePartId) || null
                  }
                  onChange={(_, newValue) =>
                    handlePartChange(index, "part", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Part Name"
                      variant="standard"
                      style={{ width: "11rem" }}
                      error={part.touched && !part.sparePartName}
                      helperText={
                        part.touched && !part.sparePartName
                          ? "Part name is required"
                          : ""
                      }
                      required
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={3} md={4}>
                <TextField
                  label="Quantity"
                  variant="standard"
                  size="small"
                  value={part.quantity}
                  onChange={(e) =>
                    handlePartChange(index, "quantity", e.target.value)
                  }
                  sx={{ width: "10rem" }}
                  error={part.touched && !part.quantity}
                  helperText={
                    part.touched && !part.quantity ? "Quantity is required" : ""
                  }
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={3} md={4}>
                {index === partPendingParams.partPending.length - 1 ? (
                  <CommonButton name="Add Part" handleOnClick={handleAddPart} />
                ) : (
                  <CommonButton name="Delete" handleOnClick={() => handleDeletePart(index)} />
                )}
              </Grid>
            </React.Fragment>
          ))}
          <Grid item xs={12} sm={3} md={4}>
            <TextField
              label="Engineer Remark"
              variant="standard"
              size="small"
              value={partPendingParams.remarks}
              onChange={(e) =>
                setPartPendingParams((prev) => ({
                  ...prev,
                  remarks: e.target.value,
                }))
              }
              sx={{ width: "20rem" }}
            />
          </Grid>
        </Grid>
      )}
      {selectedAction === 4 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3} md={3}>
            <Typography sx={{ fontSize: "900", fontWeight: "600" }}>
              Resolved with Remarks
            </Typography>
          </Grid>
        </Grid>
      )}
      {selectedAction === 4 && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={8} md={8}>
            <TextField
              label="Remarks"
              variant="outlined"
              size="small"
              fullWidth
              multiline
              rows={4}
              value={remarksParams.remarks}
              onChange={(e) =>
                setRemarksParams((prev) => ({
                  ...prev,
                  remarks: e.target.value,
                }))
              }
              sx={{ mt: 2 }}
              required
              error={remarksParams.touched && !remarksParams.remarks.trim()}
              helperText={
                remarksParams.touched && !remarksParams.remarks.trim()
                  ? "Remarks are required"
                  : ""
              }
            />
          </Grid>
        </Grid>
      )}
      <br />
      <Grid container spacing={2} justifyContent="flex-end">
        <Grid item xs={6} sm={3} md={2}>
          <CommonButton
            name="Update"
            handleOnClick={() => {
              if (selectedAction === 1) {
                setRepairWithPartParams((prev) => ({
                  ...prev,
                  jobId: jobID,
                }));
                repairWithPart();
                fetchJobStatus();
              } else if (selectedAction === 2) {
                setReplacementWithPartParams((prev) => ({
                  ...prev,
                  jobId: jobID,
                }));
                replacementWithPart();
                fetchJobStatus();
              } else if (selectedAction === 3) {
                setPartPendingParams((prev) => ({
                  ...prev,
                  jobId: jobID,
                  warrantyStatus: repairWithPartParams.warrantyStatus,
                }));
                partPending();
                fetchJobStatus();
                } else if (selectedAction === 4) {
                handleRemarksSubmit();
                fetchJobStatus();
              }
              // else{
              //   onClose();
              // }
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <CommonButton name="Cancel" handleOnClick={handleCancel} />
        </Grid>
      </Grid>
      <Dialog open={remarksDialogOpen} onClose={handleRemarksDialogClose}>
        <DialogTitle>Confirm Remarks</DialogTitle>
        <DialogContent>
          <Typography>
            Are you sure you want to submit the following remarks?
          </Typography>
          <Typography sx={{ mt: 2 }}>{remarksParams.remarks}</Typography>
        </DialogContent>
        <DialogActions>
          <CommonButton
            name="Cancel"
            handleOnClick={handleRemarksDialogClose}
          />
          <CommonButton
            name="Confirm"
            handleOnClick={handleRemarksSubmit}
            sx={{ backgroundColor: "#4CAF50", color: "white" }}
          />
        </DialogActions>
      </Dialog>
      {loading && <Loader />}
    </Box>
  );
};

export default RepairUpdate;
